import { ChevronLeft } from 'lucide-react'
import { FC, useMemo } from 'react'
import { Link, useLocation, useNavigate } from 'react-router'
import r from 'routes'

import ShieldLogo from '@/assets/journey-icon.svg?react'
import Logo from '@/assets/journey-logo.svg?react'
// import MobileNav from './mobile-nav'
import AppSelector from './app-selector'
import { isAdmin } from '@/out/admin'
import { useAppSelector, useAuthSelector, useBillingSelector } from '@/store'
import AccountDropdown from './account-hover'
import CreditInfo from './credit-info'
import DesktopNav from '../navigation/desktop-nav'
import GhostMode from './ghost'
import InactiveAppNav from '../navigation/inactive-app-nav'
import GlobalSearch from '../global-search/index'
import NotifsHover from './notifs-hover'

const LayoutHeader: FC = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { app } = useAppSelector()
  const billing = useBillingSelector()
  const { role } = useAuthSelector()

  const status = useMemo(() => (app && app in billing ? billing[app].status : undefined), [app, billing])

  return (
    <header className="sticky top-0 z-50 flex flex-col justify-center flex-shrink-0 gap-2 bg-background h-14">
      <div className="flex items-center gap-4">
        <div className="flex items-center flex-shrink-0 min-w-0 gap-2" data-testid="shield-header-logo">
          <Link to={r.root} className="flex flex-row items-center gap-2 px-4">
            <ShieldLogo className="mr-0 p-0.5 h-8 w-auto shrink-0 flex-none block" />
            <Logo className="my-[7px] px-0.5 pr-0.5 h-5 w-auto max-w-full shrink-0 flex-none hidden lg:block" />
          </Link>

          {pathname.startsWith(r.settings.root) ? (
            <div
              className="flex items-center space-x-2 cursor-pointer h-9 text-foreground/70 hover:text-foreground group"
              onClick={() => navigate(r.root)}
            >
              <ChevronLeft
                size={14}
                className="flex items-center transition-transform duration-150 ease-out group-hover:-translate-x-0.5"
              />
              <span className="text-sm font-medium">Back to apps</span>
            </div>
          ) : pathname !== r.root ? (
            <AppSelector />
          ) : null}
          {status !== 'inactive' ? <DesktopNav /> : <InactiveAppNav />}
        </div>

        <div className="flex items-center justify-end flex-1 gap-2">
          {isAdmin(role) && (
            <>
              {status === 'free-trial' && pathname !== r.root && <CreditInfo />}
              <GlobalSearch />
              <NotifsHover />
              <AccountDropdown />
            </>
          )}

          <GhostMode />
        </div>
      </div>
    </header>
  )
}

export default LayoutHeader
